import {RoomList} from "./roomList";

export abstract class ChatStoreBase {
    abstract connect: (options: any) => Promise<void>
    abstract disconnect: () => Promise<void>
    abstract roomList?: RoomList
}

